import React from 'react';
import { Bell } from 'lucide-react';
export const NotificationBellButton = ({ count }) => (<React.Fragment>
        <Bell className="h-5 w-5"/>

        {count > 0 && (<span className="absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium text-white">
                {count > 9 ? '9+' : count}
            </span>)}
    </React.Fragment>);
